import { DatePipe } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { ColDef, GridOptions, ValueGetterParams } from "ag-grid-community";
import { AgGridHelperService } from 'src/app/reusables/services/ag-grid-helper.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { PointStoreProductOrderService } from '../../services/point-store-product-order.service';
import { ShoppingCartService } from '../../services/shopping-cart.service';
import { DeleteBtnRenderedComponent } from '../../custom-renders/delete-btn-rendered/delete-btn-rendered.component';
import { QtyInputRenderedComponent } from '../../custom-renders/qty-input-rendered/qty-input-rendered.component';
import { ShoppingCartLandingComponent } from '../shopping-cart-landing/shopping-cart-landing.component';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { ToastrManager } from '@niceltd/sol/toastr';
import { SubtotalRenderedComponent } from '../../custom-renders/subtotal-rendered/subtotal-rendered.component';
import { FooterSubtotalRenderedComponent } from '../../custom-renders/footer-subtotal-rendered/footer-subtotal-rendered.component';
import { FooterButtonRenderedComponent } from '../../custom-renders/footer-button-rendered/footer-button-rendered.component';
import { FooterEmptyRenderedComponent } from '../../custom-renders/footer-empty-rendered/footer-empty-rendered.component';
import { CvCustomDialogService } from 'src/app/reusables/custom-dialog/cv-custom-dialog.service';
import { CvNumberLocalizePipe } from '../../../../../reusables/pipes/cv-number-localize.pipe';
import { AgGridAngular } from 'ag-grid-angular';

@Component({
    selector: 'cv-shopping-cart-list',
    templateUrl: './shopping-cart-list.component.html',
    styleUrls: ['./shopping-cart-list.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ShoppingCartListComponent implements OnInit {
    @ViewChild('shoppingCardListGrid') agGrid: AgGridAngular;

    pscs = null;
    pspos = null;
    components: any;
    totalCalculated: number = 0;
    staticQuantity = [];
    _data = null;
    _localizationStrings = new Map();
    filterValue = ""; // This variable contains the contents of the search bar.
    showFilter = false;
    gridOptions = null; // Ag-grid confugration
    disabledItems = 0;
    loading: boolean = false;
    public isCxOne: boolean = false;
    @Output() backToBrowseEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() goToOrdersEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() setSelectedImageEvent: EventEmitter<any> = new EventEmitter<any>();


    constructor(
        private pointStoreProductOrderService: PointStoreProductOrderService,
        private shoppingCartService: ShoppingCartService,
        private agGridHelperService: AgGridHelperService,
        private cvLocalizationService: CVLocalizationService,
        private datePipe: DatePipe,
        //private shoppingCartLandingComponent: ShoppingCartLandingComponent,
        public config: CvConfigurationService,
        private toastrManager: ToastrManager,
        public cvNumberLocalize: CvNumberLocalizePipe,
        private cvConfigurationService: CvConfigurationService,
        private dialogService?: CvCustomDialogService,
    ) {
        // this.shoppingCartService.getSessionCart();
        // this.shoppingCartService.getFullLogin();
        this.pscs = this.shoppingCartService.shoppingCartObj;
        this.pspos = this.pointStoreProductOrderService.pointStoreProductOrderObj;
        this.components = {
            buttonRenderer: DeleteBtnRenderedComponent,
            footerbuttonRenderer: FooterButtonRenderedComponent,
            qtyRenderer: QtyInputRenderedComponent,
            subtotalRenderer: SubtotalRenderedComponent,
            footerSubtotalRenderer: FooterSubtotalRenderedComponent,
            footerEmptyRenderer: FooterEmptyRenderedComponent
        }
        this.isCxOne = cvConfigurationService.isCxOne;
        this.pscs.shoppingCartIsCheckingQty = false;
        this.pscs.shoppingCartIsQtyInputEmpty = false;
        this.pscs.shoppingCartwasCartUpdated = false;
        this.pscs.shoppingDisableCheckout = false;
    }

    ngOnInit(): void {
        // this.loadLocalizations();
        // this.loadData();

        //Improve data loading
        this.synchronizeData();
    }

    async synchronizeData() {
        this.loading = true;
        let tempShoppingCartObject = Object.assign({}, this.pscs);

        await this.shoppingCartService.getFullLogin();
        await this.shoppingCartService.getLandingInfo();
        await this.shoppingCartService.getSessionCart();
        await this.shoppingCartService.checkShopingCartExistencies();

        this.loadLocalizations();
        this.loadData();

        this.loading = false;

        if (this.cvConfigurationService.isCxOne) {
            this.shoppingCartService.configureCurrentFilter(tempShoppingCartObject);
        }

    }

    loadLocalizations() {
        this.cvLocalizationService.GetSection("MarketPlace").then((map) => {
            this._localizationStrings = map;
        }).finally(() => {
            this.setupGrid();
        });
    }

    getLocalizationString(key, defaultValue) {
        if (this._localizationStrings && this._localizationStrings.has(key))
            return this._localizationStrings.get(key);
        return defaultValue;
    }

    setupGrid() {
        this.gridOptions = this.agGridHelperService.createGridOptions({
            getRowHeight: (params) => {
                return params.data != null ? 125 : 60;
            },
            headerHeight: this.isCxOne ? 43 : 32,
            //angularCompileRows: true,
            overlayNoRowsTemplate: `
        <span>
            <img style="margin-bottom:8px; width: 35px; height: 35px; display: block; margin: 0 auto;" src="../App_Themes/Standard/Images/AgentOrderHistory/cart.svg"/>
            <span style="font-size:16px; color: #A8AFB9; margin-bottom: 8px;">${this.getLocalizationString("Empty_Cart", "Your cart is empty")}</span>
        </span>
      `,
            rowSelection: 'multiple',
            rowMultiSelectWithClick: true,
            suppressCellFocus: true,
            suppressRowClickSelection: true,
            suppressContextMenu: true,
            suppressDragLeaveHidesColumns: true,
            defaultColDef: {
                sortable: true,
                filter: true,
                resizable: true,
                width: 150,
            },
            columnDefs: [
                {
                    field: "Title",
                    colId: "ProductID",
                    width: 300,
                    headerName: this.getLocalizationString("Title", "Title"),
                    filter: "agTextColumnFilter",
                    suppressMovable: true,
                    suppressMenu: true,
                    cellRenderer: (params) => {
                        if (params.data != null) {
                            if (params.data.TitleFooter != null) {
                                return '';
                            }
                            let productDetailContainer = $('<div>').addClass('d-flex');
                            let imgContainer = $('<div>').addClass('imageContainer');
                            let img = document.createElement('img');
                            let matchedProduct = this.pscs.pointStoreProducts.find((p) => { return p.PointStoreProductID == params.data.ProductID; });
                            let isVariationActive = true;
                            let isAProductModified = false;
                            let hasExistencies = true;

                            if (params.data.ProductImageID != null && params.data.ProductImageID > 0) {
                                if (params.data.Variation != null && params.data.Variation > 0 && params.data.VariationImgID != null && params.data.VariationImgID > 0) {
                                    if (this.isCxOne) {
                                        if (matchedProduct == null) {
                                            img.src = '../Admin/ImageResizer.aspx?imgid=' + params.data.ProductImageID + '&w=auto&h=200';
                                        } else {
                                            img.src = '../Admin/ImageResizer.aspx?imgid=' + params.data.VariationImgID + '&w=auto&h=200';
                                        }
                                    } else {
                                        img.src = '../Admin/ImageResizer.aspx?imgid=' + params.data.VariationImgID + '&w=auto&h=200';
                                    }
                                } else
                                    img.src = '../Admin/ImageResizer.aspx?imgid=' + params.data.ProductImageID + '&w=auto&h=200';

                                $(img).addClass('cart-product-image');
                                if (this.isCxOne) {
                                    $(img).addClass('cxone-cpi-border');
                                }
                                $(img).appendTo(imgContainer);

                            } else {
                                if (params.data.Variation != null && params.data.Variation > 0 && params.data.VariationImgID != null && params.data.VariationImgID > 0) {

                                    if (this.isCxOne) {
                                        if (matchedProduct == null) {
                                            //svg container
                                            let svgContainer = document.createElement('div');
                                            svgContainer.classList.add('cxone-cart-product-container-svg-not-available', 'd-flex', 'flex-column', 'justify-content-center', 'align-items-center');
                                            //svg image
                                            let svgImage = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                                            svgImage.classList.add('cxone-cart-product-svg-not-available');
                                            svgImage.innerHTML = `<use href="../App_Themes/CXone/icons/not-available-image.svg#not-available-image"></use>`;
                                            $(svgImage).appendTo(svgContainer);
                                            $(svgContainer).appendTo(imgContainer);
                                        } else {
                                            img.src = '../Admin/ImageResizer.aspx?imgid=' + params.data.VariationImgID + '&w=auto&h=200';
                                            $(img).addClass('cart-product-image');
                                            $(img).addClass('cxone-cpi-border');
                                            $(img).appendTo(imgContainer);
                                        }
                                    } else {
                                        img.src = '../Admin/ImageResizer.aspx?imgid=' + params.data.VariationImgID + '&w=auto&h=200';
                                        $(img).addClass('cart-product-image');
                                        $(img).appendTo(imgContainer);
                                    }
                                } else {
                                    if (this.isCxOne) {
                                        //svg container
                                        let svgContainer = document.createElement('div');
                                        svgContainer.classList.add('cxone-cart-product-container-svg-not-available', 'd-flex', 'flex-column', 'justify-content-center', 'align-items-center');
                                        //svg image
                                        let svgImage = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                                        svgImage.classList.add('cxone-cart-product-svg-not-available');
                                        svgImage.innerHTML = `<use href="../App_Themes/CXone/icons/not-available-image.svg#not-available-image"></use>`;
                                        $(svgImage).appendTo(svgContainer);
                                        $(svgContainer).appendTo(imgContainer);
                                    } else {
                                        img.src = '../Admin/ImageResizer.aspx?imgid=-16&w=auto&h=80';
                                        $(img).addClass('cart-product-image');
                                        $(img).appendTo(imgContainer);
                                    }
                                }
                            }
                            imgContainer.appendTo(productDetailContainer);

                            //Product Name
                            let $productName = $('<span>').addClass('cell-vertical-align shopping-cart-list-title');
                            $productName.text(params.value).appendTo(productDetailContainer);

                            //Check if product is no longer available
                            let iconDisabled = document.createElement('div');
                            iconDisabled.setAttribute('title', this.getLocalizationString("Not_Available_Item", "This item is no longer available."));
                            $(iconDisabled).addClass('cell-vertical-align');
                            if (matchedProduct != null && params.data.Variation != null && params.data.Variation > 0) {
                                if (matchedProduct.VariationsData) {
                                    if (matchedProduct.VariationsData.find((mp) => { return mp.PointStoreProductVariationID == params.data.Variation && mp.Active }) == null)
                                        isVariationActive = false;
                                } else {
                                    //check if the item added to the cart with variation has no variations now
                                    isAProductModified = true;
                                }
                            }
                            //check if the item added to the cart without variations has variations now
                            if (matchedProduct != null && matchedProduct.VariationsData != null && matchedProduct.VariationsData.length > 0) {
                                if (params.data.Variation == null || params.data.Variation == 0) {
                                    isAProductModified = true;
                                }
                            }

                            //check the existencies of a product, if it is 0 = false, else = true;
                            hasExistencies = this.checkProductQuantity(params.data);


                            if (matchedProduct == null || !isVariationActive || isAProductModified || !hasExistencies) {
                                this.disabledItems++;
                                if (this.cvConfigurationService.isCxOne) {
                                    imgContainer.addClass('cxone-no-longer-available');
                                    let divHover = document.createElement('div');
                                    divHover.className = 'cxone-hover-no-longer-available';
                                    divHover.innerHTML = '<svg class="icon-20 cxone-icon-no-longer-available"><use href="../App_Themes/CXone/icons/no-longer-available.svg#no-longer-available"></use></svg>';
                                    $(divHover).appendTo(imgContainer);

                                } else {
                                    iconDisabled.innerHTML = `<svg class="icon-16 fill-valyrianSteel ml-2"><use href="../App_Themes/clearview-default/icons/utility/error.svg#error"></use></svg>`;
                                    $(iconDisabled).appendTo(productDetailContainer);
                                }
                            }
                            return productDetailContainer[0];
                        } else if (this.disabledItems > 0) {
                            let disabledItemsMssg =
                                `<div class="availability-message color-valyrianSteel d-flex align-items-center" [hidden]="!(ctrlshoppingCartList.disabledItems > 0)">
                      <svg class="icon-16 fill-valyrianSteel mr-2"><use href="../App_Themes/clearview-default/icons/utility/error.svg#error"></use></svg>
                      <span>${this.getLocalizationString("Not_Available_Items", "These items are no longer available.")}</span>
                  </div>`;
                            return disabledItemsMssg;
                        }
                    },
                    cellClass: "cell-vertical-align cart-product-name color-whaleTail",
                },
                {
                    field: 'Variation',
                    headerName: this.isCxOne ? this.getLocalizationString('Variant', 'Variant') : this.getLocalizationString("Variation", "Variation"),
                    filter: 'agTextColumnFilter',
                    cellClass: "cell-vertical-align color-whaleTail",
                    suppressMovable: true,
                    suppressMenu: true,
                    valueFormatter: (params) => {
                        if (params.data != null) {
                            if (params.data.VariationName != null)
                                return params.data.VariationName;
                            else
                                return 'N/A';
                        }
                    },
                    comparator: (valueA, valueB, nodeA, nodeB) => {
                        let variationA = nodeA.data.VariationName != null ? nodeA.data.VariationName.toUpperCase() : 'N/A';
                        let variationB = nodeB.data.VariationName != null ? nodeB.data.VariationName.toUpperCase() : 'N/A';
                        if (variationA == variationB) return 0;
                        return (variationA > variationB) ? 1 : -1;
                    },
                },
                {
                    field: 'CalculatedRealPrice',
                    headerName: this.getLocalizationString("Price_per_Unit", "Price per unit"),
                    filter: 'agNumberColumnFilter',
                    cellClass: "cell-vertical-align color-whaleTail" + (this.isCxOne ? ' text-lowercase' : ''),
                    suppressMovable: true,
                    suppressMenu: true,
                    valueFormatter: (params) => {
                        if (params.data != null) {
                            return this.cvNumberLocalize.transform(params.value) + " " + ((this.cvNumberLocalize.transform(params.value) == 1 ? this.getLocalizationString("Coin", "Coin") : this.getLocalizationString("Coins", "Coins")));
                        }
                    },
                },
                {
                    field: 'Quantity',
                    headerName: this.getLocalizationString("Quantity", "Quantity"),
                    filter: 'agNumberColumnFilter',
                    cellClass: "cell-vertical-align input-quantity color-whaleTail",
                    suppressMovable: true,
                    suppressMenu: true,
                    // cellRenderer: 'qtyRenderer',
                    cellRendererSelector: (params) => {
                        return {
                            component: 'qtyRenderer'
                        }
                    }
                },
                {
                    field: 'Subtotal',
                    headerName: this.getLocalizationString("Subtotal", "Subtotal"),
                    suppressMenu: true,
                    valueGetter: (params) => {
                        return params.data.CalculatedRealPrice * params.data.Quantity;
                    },
                    cellClass: "cell-vertical-align color-whaleTail" + (this.isCxOne ? ' text-lowercase' : ''),
                    suppressMovable: true,
                    cellRendererSelector: (params) => {
                        return {
                            component: 'subtotalRenderer'
                        };
                    },
                    // aggFunc: "sum",
                },
                {
                    field: 'Action',
                    headerName: this.getLocalizationString("Action", "Action"),
                    cellClass: "cell-vertical-align color-whaleTail",
                    sortable: false,
                    suppressMovable: true,
                    suppressMenu: true,
                    cellRendererSelector: (params) => {
                        return {
                            component: 'buttonRenderer'
                        };
                    },
                }
            ],
            singleClickEdit: true,
            domLayout: this.pscs.pointStoreCart.pointStoreProducts.length < 1 || this.pscs.pointStoreCart.pointStoreProducts.length >= 3 ? 'normal' : 'autoHeight',
            // groupIncludeFooter: true,
            // groupIncludeTotalFooter: true,
            onGridReady: (params) => {
                this.disabledItems = 0;
                if (this._data != this.pscs.pointStoreCart.pointStoreProducts)
                    this._data = this.pscs.pointStoreCart.pointStoreProducts;
                if (this.pscs.pointStoreCart.pointStoreProducts.length < 1 || this.pscs.pointStoreCart.pointStoreProducts.length >= 3) {
                    this.agGrid?.api.setDomLayout('normal');
                    (<HTMLElement>document.querySelector('#cart-grid')).style.height = '90%';
                } else {
                    this.agGrid?.api.setDomLayout('autoHeight');
                    (<HTMLElement>document.querySelector('#cart-grid')).style.height = '';
                }
                if (this._data) {
                    params.api.setGridOption('rowData', this._data);
                }
                if (this._data != null && this._data.length > 0) {
                    params.api.hideOverlay();
                } else {
                    this.gridOptions.noRowsOverlayComponent = null;
                    params.api.showNoRowsOverlay();
                }
                params.api.sizeColumnsToFit();
            },
            getRowId: ({ data: rowData }) => rowData.Variation == null ? rowData.ProductID : `${rowData.ProductID}${rowData.Variation}`,
            // The filter can also be set with the setQuickFilter() api call on the grid.
            //isExternalFilterPresent: function () { // External Filter refers to our search bar.  This function returns true when ctrl.filterValue has content, false when otherwise.  False causes ag-grid to show all row values.
            //    return ctrl.evtGlCtrl.searchTerm.length > 0;
            //},
            //doesExternalFilterPass: function (node) { // This function actually uses the value of the search bar, and it compares it to the data of the row ag-grid is passing in (node).  Use AgGridHelperService's unless you have good reason.
            //    return AgGridHelperService.doesExternalFilterPass(node, ctrl.evtGlCtrl.searchTerm);
            //},
            onSortChanged: (event) => {
                //queueStateSave();
                event.api.sizeColumnsToFit();
            },
            onColumnMoved: (event) => {
                //queueStateSave();
                event.api.sizeColumnsToFit();
            },
            onColumnPinned: (event) => {
                //queueStateSave();
                event.api.sizeColumnsToFit();
            },
            onColumnVisible: (event) => {
                event.api.sizeColumnsToFit();
                //queueStateSave();
            },
            onGridSizeChanged: (event) => {
                event.api.sizeColumnsToFit();
            },
            onRowSelected: this.onRowSelected,
        });
    }

    loadData() {
        this._data = this.pscs.pointStoreCart.pointStoreProducts;
        if (this.gridOptions && this.agGrid?.api) {
            this.agGrid?.api.setGridOption('rowData', this._data);
            let lastColumnSorted = <HTMLElement>document.getElementsByClassName('ag-header-icon ag-header-cell-menu-button')[5];
            if (lastColumnSorted) {
                lastColumnSorted.style.display = 'none';
            }
        } // else, the grid's onGridReady() event handler should load up its initial values.
        else {
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    }

    onRowSelected(event) {
        event.node.data.IsChecked = event.node.isSelected();
    }

    goToBrowse() {
        $(".linee").show();
        // this.shoppingCartLandingComponent.backToBrowse();
        this.backToBrowseEvent.emit();
    }

    goToOrders() {
        $(".linee").hide();
        this.pscs.shoppingCartShowLoader = true;
        if (!this.isCxOne) {
            this.pointStoreProductOrderService.LoadPointStoreProductHistoryOrders();
        }
        this.pscs.shoppingCartShowLoader = false;

        this.pscs.pointStoreVisibleContent.showLandingPage = false;
        this.pscs.pointStoreVisibleContent.showOrdersPage = true;
        this.pscs.pointStoreVisibleContent.showShoppingCartPage = false;

        this.goToOrdersEvent.emit();
    }

    enableCheckout() {
        if (this.pscs.fullGammificationProfile == null) //For when the market is loading and the profile hasn't been set.
            return false;
        if (this.pscs.pointStoreCart.pointStoreProducts.length < 1)
            return false;
        if (this.disabledItems > 0)
            return false;

        let totalCheck = this.getTotal() <= this.pscs.fullGammificationProfile.AvailableSpendingPoints;
        let notAlreadyProcessing = !this.pscs.pointStoreCheckOutInProcess;
        let quantityValidation = true;
        for (let i = 0; i < this.pscs.pointStoreCart.pointStoreProducts.length; i++) {
            let productID = this.shoppingCartService.GetProductCartId(this.pscs.pointStoreCart.pointStoreProducts[i]);
            if (this.pscs.pointStoreProductValidation[productID]) {
                quantityValidation = false;
                break;
            }
        }

        return (totalCheck && notAlreadyProcessing && quantityValidation);
    }

    async checkOut() {
        if (this.pscs.shoppingCartIsQtyInputEmpty || this.pscs.shoppingCartIsCheckingQty || this.pscs.shoppingDisableCheckout) return;
        this.pscs.shoppingCartShowLoader = true;
        let tempShoppingCartObject = Object.assign({}, this.pscs);

        const responseResult = await this.shoppingCartService.checkoutShoppingCart();
        if (responseResult) {
            await this.shoppingCartService.getCarouselItems();
            if (this.cvConfigurationService.isCxOne) {
                setTimeout(() => {
                    this.setSelectedImageEvent.emit();
                }, 100);
            }
            this._data = this.pscs.pointStoreCart.pointStoreProducts;
            this.pscs.shoppingCartShowLoader = false;
            //empty the pointStoreProductValidation list
            this.pscs.pointStoreProductValidation = {};
            if (this.cvConfigurationService.isCxOne) {
                this.toastrManager.showToaster('success', this.getLocalizationString("Order_Placed_Successfully", "Order placed successfully."));
                this.shoppingCartService.configureCurrentFilter(tempShoppingCartObject);
            }
        } else {
            this._data = this.pscs.pointStoreCart.pointStoreProducts;
            this.agGrid?.api.setGridOption('rowData', this._data);
            let paramsColumn = {
                force: true,
                suppressFlash: true
            };
            this.agGrid?.api.refreshCells(paramsColumn);
            this.pscs.shoppingCartShowLoader = false;
        }
    }

    getTotal() {
        return this.shoppingCartService.getCartTotal();
    }

    async deleteItemFromCart(product) {
        this.pscs.shoppingCartIsCheckingQty = true;
        this.pscs.shoppingCartShowLoader = true;
        let tempShoppingCartObject = Object.assign({}, this.pscs);
        await this.shoppingCartService.getLandingInfo();
        let response: any = await this.shoppingCartService.deleteItemFromCart(product);
        if (response.status_code == 200) {

            let matchedProduct = this.pscs.pointStoreProducts.find((p) => { return p.PointStoreProductID == product.ProductID; });
            if (matchedProduct == null) {
                this.disabledItems--;
            }
            else if (matchedProduct.VariationsData != null) {
                let selectedVariationData = matchedProduct.VariationsData.find((v) => { return v.PointStoreProductVariationID == product.Variation; });
                if (selectedVariationData) {
                    if (!selectedVariationData.Active) {
                        this.disabledItems--;
                    }
                    else {
                        //if the deleted variation item is active but out of stock
                        this.checkProductQuantityDeleted(product);
                    }
                } else {
                    //If the deleted product we added to the cart and it had no variations, but the variations were added later, in this scenario we will have a product.Variation == 0
                    this.disabledItems--;
                }
            } else if (matchedProduct.Quantity == 0) {
                //If the product we deleted is out of stock
                this.disabledItems--;
            }

            await this.shoppingCartService.checkShopingCartExistencies();
            this._data = this.pscs.pointStoreCart.pointStoreProducts;
            this.agGrid?.api.setGridOption('rowData', this._data);
            this.disabledItems = 0;
            let paramsColumn = {
                force: true,
                suppressFlash: true
            };
            this.agGrid?.api.refreshCells(paramsColumn);

            if (this.pscs.pointStoreCart.pointStoreProducts.length < 1 || this.pscs.pointStoreCart.pointStoreProducts.length >= 3) {
                this.agGrid?.api.setDomLayout('normal');
                // when auto height is off, the grid ahs a fixed height, and then the grid
                // will provide scrollbars if the data does not fit into it.
                (<HTMLElement>document.querySelector('#cart-grid')).style.height = '65%';
            } else {
                this.agGrid?.api.setDomLayout('autoHeight');
                // auto height will get the grid to fill the height of the contents,
                // so the grid div should have no height set, the height is dynamic.
                (<HTMLElement>document.querySelector('#cart-grid')).style.height = '';
            }
            if (this.pscs.pointStoreProductCarouselItems.findIndex((p) => { return p.PointStoreProductID === product.ProductID; }) > -1) {
                this.shoppingCartService.getCarouselItems();
                if (this.cvConfigurationService.isCxOne) {
                    setTimeout(() => {
                        this.setSelectedImageEvent.emit();
                    }, 100);
                }
            }

            this.totalCalculated = this.getTotal();

            this.pscs.shoppingCartShowLoader = false;

            if (this.pscs.pointStoreDetailedViewProduct != null) {
                let currentProductUpdated = this.pscs.pointStoreProducts.find(p => p.PointStoreProductID == this.pscs.pointStoreDetailedViewProduct.PointStoreProductID);
                if (currentProductUpdated != null) {
                    this.pscs.pointStoreDetailedViewProduct.Quantity = currentProductUpdated.Quantity;
                }
            }

            if (this.cvConfigurationService.isCxOne) {
                this.shoppingCartService.configureCurrentFilter(tempShoppingCartObject);
            }
            this.pscs.shoppingCartwasCartUpdated = true;
            this.pscs.shoppingCartIsCheckingQty = false;
            this.pscs.shoppingCartIsQtyInputEmpty = false;
            this.pscs.shoppingDisableCheckout = false;
        }
        else {
            this.pscs.shoppingCartwasCartUpdated = true;
            this.pscs.shoppingCartIsCheckingQty = false;
            this.pscs.shoppingCartIsQtyInputEmpty = false;
            this.pscs.shoppingDisableCheckout = false;
            throw response;
        }
    }

    validateInput(e) {
        if (!((e.keyCode > 95 && e.keyCode < 106)
            || (e.keyCode > 47 && e.keyCode < 58)
            || e.keyCode == 8)) {
            return false;
        }
    }

    async updateCart(product): Promise<number> {
        // 0 = error, 1 = successfull, 2 = not enough stock
        let isAValidTrasanction: number = 1;


        try {
            let staticQuantityCheck = false;
            this.pscs.shoppingCartShowLoader = true;
            let tempShoppingCartObject = Object.assign({}, this.pscs);

            await this.shoppingCartService.getLandingInfo();
            if (this.cvConfigurationService.isCxOne) {
                this.shoppingCartService.configureCurrentFilter(tempShoppingCartObject);
            }

            let productID = this.shoppingCartService.GetProductCartId(product);

            if (product.Variation != null && product.Variation > 0) {
                let matchedProduct = this.pscs.pointStoreProducts.find((p) => { return p.PointStoreProductID == product.ProductID; });
                if (matchedProduct) {
                    if (matchedProduct.VariationsData != null) {
                        let selectedVariation = matchedProduct.VariationsData.find((v) => { return v.PointStoreProductVariationID == product.Variation; });
                        if ((typeof (selectedVariation.VariationQuantity) === 'undefined') || selectedVariation.VariationQuantity == "" || selectedVariation.VariationQuantity == 0 || selectedVariation.VariationQuantity == null) {
                            selectedVariation.VariationQuantity = this.staticQuantity[product.ProductID];
                            staticQuantityCheck = true;
                        }
                    }
                } else {
                    //if matchedProduct is null and product.Variation != null && product.Variation > 0, this product was added, but the product expired or was later deleted.
                    this.pscs.shoppingCartShowLoader = false;
                    isAValidTrasanction = 2;
                    return isAValidTrasanction;
                }
            } else {
                if ((typeof (product.Quantity) === 'undefined') || product.Quantity == "" || product.Quantity == 0 || product.Quantity == null) {
                    product.Quantity = this.staticQuantity[product.ProductID];
                    staticQuantityCheck = true;
                }
            }
            if (!staticQuantityCheck) {
                return await this.shoppingCartService.checkProductExistenciesWS(product, false, product.Quantity).then(
                    async (result: any) => {
                        if (result == true) {
                            return await this.shoppingCartService.updateQuantity(product).then(async (data) => {

                                await this.shoppingCartService.checkShopingCartExistencies();
                                if (this.pscs.pointStoreProductCarouselItems.findIndex((p) => { return p.PointStoreProductID === product.ProductID; }) > -1) {
                                    this.shoppingCartService.getCarouselItems();
                                    if (this.cvConfigurationService.isCxOne) {
                                        setTimeout(() => {
                                            this.setSelectedImageEvent.emit();
                                        }, 100);
                                    }
                                }

                                this.pscs.shoppingCartShowLoader = false;

                                if (this.pscs.pointStoreDetailedViewProduct != null) {
                                    let currentProductUpdated = this.pscs.pointStoreProducts.find(p => p.PointStoreProductID == this.pscs.pointStoreDetailedViewProduct.PointStoreProductID);
                                    if (currentProductUpdated != null) {
                                        this.pscs.pointStoreDetailedViewProduct.Quantity = currentProductUpdated.Quantity;
                                    }
                                }

                                if (this.cvConfigurationService.isCxOne) {
                                    this.shoppingCartService.configureCurrentFilter(tempShoppingCartObject);
                                }

                                isAValidTrasanction = 1;
                                return isAValidTrasanction;

                            }).catch((result: any) => {
                                this.pscs.shoppingCartShowLoader = false;
                                isAValidTrasanction = 0;
                                return isAValidTrasanction;
                            });

                        } else {
                            this.pscs.shoppingCartShowLoader = false;

                            isAValidTrasanction = 2;
                            return isAValidTrasanction;

                        }
                    }).catch((result: any) => {
                        this.pscs.shoppingCartShowLoader = false;
                        isAValidTrasanction = 0;
                        return isAValidTrasanction;
                    });

            } else {
                return await this.shoppingCartService.updateQuantity(product).then((data) => {
                    if (this.pscs.pointStoreProductCarouselItems.findIndex((p) => { return p.PointStoreProductID === product.ProductID; }) > -1) {
                        this.shoppingCartService.getCarouselItems();
                        if (this.cvConfigurationService.isCxOne) {
                            setTimeout(() => {
                                this.setSelectedImageEvent.emit();
                            }, 100);
                        }
                    }

                    this.shoppingCartService.shoppingCartObj.pointStoreProductValidation[productID] = false;
                    this.pscs.shoppingCartShowLoader = false;

                    if (this.pscs.pointStoreDetailedViewProduct != null) {
                        let currentProductUpdated = this.pscs.pointStoreProducts.find(p => p.PointStoreProductID == this.pscs.pointStoreDetailedViewProduct.PointStoreProductID);
                        if (currentProductUpdated != null) {
                            this.pscs.pointStoreDetailedViewProduct.Quantity = currentProductUpdated.Quantity;
                        }
                    }

                    if (this.cvConfigurationService.isCxOne) {
                        this.shoppingCartService.configureCurrentFilter(tempShoppingCartObject);
                    }

                    isAValidTrasanction = 1;
                    return isAValidTrasanction;

                }).catch((result: any) => {
                    this.pscs.shoppingCartShowLoader = false;
                    isAValidTrasanction = 0;
                    return isAValidTrasanction;
                });
            }
        } catch (error) {
            this.pscs.shoppingCartShowLoader = false;
            isAValidTrasanction = 0;
            return isAValidTrasanction;
        }
    }

    getCartTotalQuantity() {
        let quantity = 0;
        if (this.pscs) {
            this.pscs?.pointStoreCart.pointStoreProducts.forEach((product, key) => {
                let itemquantity = product.Quantity;
                quantity += itemquantity;
            });
        }
        return quantity;
    }

    getCartProductsWithoutQuantity() {
        let quantity = 0;
        if (this.pscs) {
            this.pscs?.pointStoreCart.pointStoreProducts.forEach((product, key) => {
                quantity++;
            });
        }
        return quantity;

    }

    isTotalPriceLargerThanNumberCoins(): boolean {
        let isLarger = false;
        isLarger = this.getTotal() > this.pscs.fullGammificationProfile.AvailableSpendingPoints;
        return isLarger;
    }

    isNoLongerAvailableItems(): boolean {
        let isNoLongerAvailable = false;
        isNoLongerAvailable = this.disabledItems > 0;
        let quantityValidation = true;
        quantityValidation = this.checkProductQuantity();
        return (isNoLongerAvailable || !quantityValidation);
    }

    /**
     * Check if the product cart is in the this.pscs.pointStoreProductValidation object
     * @param product optional parameter, if null check the complete list of this.pscs.pointStoreCart.pointStoreProducts, else check the specific item
     * @returns boolean => if true we have quantity, else we don't have quantity
     */
    checkProductQuantity(product: any = null): boolean {
        let quantityValidation = true;
        if (product) {
            let productID = this.shoppingCartService.GetProductCartId(product);
            if (this.pscs.pointStoreProductValidation[productID]) {
                quantityValidation = false;
            }
        } else {
            for (let i = 0; i < this.pscs.pointStoreCart.pointStoreProducts.length; i++) {
                let productID = this.shoppingCartService.GetProductCartId(this.pscs.pointStoreCart.pointStoreProducts[i]);
                if (this.pscs.pointStoreProductValidation[productID]) {
                    quantityValidation = false;
                    break;
                }
            }
        }
        return quantityValidation;
    }

    /**
     * Check if the productCart deleted was in the this.pscs.pointStoreProductValidation list, if true then reduce this.disabledItems--;
     * @param productCart the productCart deleted
     */

    checkProductQuantityDeleted(productCart) {
        let productID = this.shoppingCartService.GetProductCartId(productCart);
        if (this.pscs.pointStoreProductValidation[productID]) {
            if (productCart.Variation != null && productCart.Variation > 0) {
                let product = this.pscs.pointStoreCart.pointStoreProducts.find((p) => p.Varition == productCart.Variation);
                if (product == null) {
                    this.disabledItems--;
                }
            } else {
                let product = this.pscs.pointStoreCart.pointStoreProducts.find((p) => p.ProductID == productCart.ProductID);
                if (product == null) {
                    this.disabledItems--;
                }
            }
        }
    }

    async refreshGridOnNotEnoughtStockProduct() {
        this.pscs.shoppingCartShowLoader = true;
        await this.shoppingCartService.checkShopingCartExistencies();
        this.pscs.shoppingCartShowLoader = false;

    }

}
